<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M15.5 10.9165H14.8767L13.0434 12.7499H14.7942L17.3334 14.5832H2.66671L5.21504 12.7499H7.09421L5.26087 10.9165H4.50004L0.833374 13.6665V17.3332C0.833374 18.3415 1.64921 19.1665 2.65754 19.1665H17.3334C18.3417 19.1665 19.1667 18.3507 19.1667 17.3332V13.6665L15.5 10.9165ZM14.5834 6.28735L10.0459 10.8249L6.80087 7.57985L11.3384 3.04235L14.5834 6.28735ZM10.6967 1.09902L4.85754 6.93819C4.50004 7.29569 4.50004 7.87319 4.85754 8.23069L9.39504 12.7682C9.75254 13.1257 10.33 13.1257 10.6875 12.7682L16.5175 6.93819C16.875 6.58069 16.875 6.00319 16.5175 5.64569L11.98 1.10819C11.6317 0.741521 11.0542 0.741521 10.6967 1.09902Z" fill="currentColor"/>
	</svg>
</template>

<script>
  export default {};
</script>
